import locale from "csi/locale";
import csi from "csi/main";
import Widget from "csi/table/Widget";
import { QueryLevel } from "csi/view/_query/Level";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import QueryFilterBuilder from "csi/xml/QueryFilterBuilder";
import declare from "dojo/_base/declare";

const PRODUCT_TYPE = "ProductType";

const AggregateFromBaseProductTableMixin = declare(Widget, {

	/**
	 * Modifies query depending on if action is called from BOM section and selected type
	 * @param subtypeFieldName 
	 * @param subtypeAttrName 
	 * @param ql 
	 */
	modifyQuery(subtypeFieldName: string, subtypeAttrName: string, ql: QueryLevel): void {
		// Get URL of BOM Section, save it in case 'Save and New' is selected
		const controller = this.getSourceController();
		if (!controller) {
			return;
		}

		// Previous Wizard page FormData is stored in Context
		const ctx = this.getContext();
		const cache = ctx.cache;
		const itemProductTypeEnum = ctx.defView.m_formData.getFieldValue(locale.resource(PRODUCT_TYPE));
		const foodBOMSubtypeSettings = cache.getPathNode(controller.getContext().getParent(), "Child:__Parent__/Child:Subtype/Child:Settings");
		const itemActualPreference = foodBOMSubtypeSettings?.ActualItemsSelectionPreference[itemProductTypeEnum];
		const preference = xml.enumGetText(itemActualPreference);
		const baseProductTypeField = ctx.defView.m_formData.getField(locale.resource(subtypeFieldName));
		const isBaseProductTypeSelected = baseProductTypeField.getValue() !== csi.EMPTY_URL;

		const bomSectionDefinitionURL = controller.widget.get("bomSectionDefinitionURL"); // attr set in SelectFoodBOMProductForm.ts
		const isValidBomSectionURL = bomSectionDefinitionURL && bomSectionDefinitionURL !== csi.EMPTY_URL;
		const bomSectionDefinition = isValidBomSectionURL ? ctx.cache.getNode(bomSectionDefinitionURL) : null;

		// Build Query for Aggregate BaseProduct table
		const query = new Query();
		query.Attr("Active", xml.OP_EQUALS, true);
		if (isBaseProductTypeSelected) {
			// If a BaseProduct Type is selected, query for BaseProducts of that type, if preference != BaseProduct, query SKUs
			if (preference === "BaseProduct") {
				query.RefAttr(subtypeAttrName, xml.OP_EQUALS, baseProductTypeField.getValue());
			} else {
				query.RefAttr(subtypeAttrName, xml.OP_EQUALS, baseProductTypeField.getValue(), "Child:__Parent__");
			}
		} else {
			// If no BaseProduct Type is selected,
			// query for BaseProducts of PlacementProductTypes of current BOM Section, if preference != BaseProduct, query SKUs
			const placementProductTypes = bomSectionDefinition ? bomSectionDefinition.PlacementProductTypes : [];

			const qOr = placementProductTypes.length ? query.Or() : query;
			if (preference === "BaseProduct") {
				placementProductTypes.forEach((productType) => {
					const typeURL = ctx.cache.getNode(productType).$URL;
					qOr.RefAttr(subtypeAttrName, xml.OP_EQUALS, typeURL);
				});
			} else {
				placementProductTypes.forEach((productType) => {
					const typeURL = ctx.cache.getNode(productType).$URL;
					qOr.RefAttr(subtypeAttrName, xml.OP_EQUALS, typeURL, "Child:__Parent__");
				});
			}
		}

		// Apply query filter if current BOM Section has one
		const bomQueryFilter = bomSectionDefinition ? bomSectionDefinition.QueryFilter : null;
		if (bomQueryFilter && bomQueryFilter !== csi.EMPTY_URL && xml.isValidURL(bomQueryFilter)) {
			QueryFilterBuilder.create(query, bomQueryFilter, bomSectionDefinitionURL, ctx.cache);
		}

		ql.serverQuery = query;
	},
});

export = AggregateFromBaseProductTableMixin;